var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPush(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9794 24.5C12.1842 24.8547 12.4787 25.1492 12.8334 25.354C13.1881 25.5588 13.5905 25.6666 14.0001 25.6666C14.4096 25.6666 14.812 25.5588 15.1667 25.354C15.5214 25.1492 15.8159 24.8547 16.0207 24.5M17.5001 9.33334H24.5001M21.0001 5.83334V12.8333M23.3357 16.8747C23.6012 17.2281 23.8888 17.5644 24.1967 17.8815C24.3489 18.0487 24.4492 18.2566 24.4854 18.4798C24.5216 18.7029 24.4922 18.9318 24.4008 19.1386C24.3093 19.3454 24.1597 19.5211 23.9702 19.6445C23.7807 19.7678 23.5595 19.8334 23.3334 19.8333H4.66672C4.44062 19.8334 4.21937 19.7678 4.02987 19.6445C3.84038 19.5211 3.69081 19.3454 3.59935 19.1386C3.50789 18.9318 3.47848 18.7029 3.5147 18.4798C3.55093 18.2566 3.65122 18.0487 3.80338 17.8815C5.35505 16.282 7.00005 14.5822 7.00005 9.33334C7.00019 8.13282 7.30908 6.9525 7.89705 5.90582C8.48502 4.85913 9.3323 3.98126 10.3575 3.35654C11.3827 2.73183 12.5513 2.38128 13.751 2.33857C14.9508 2.29586 16.1414 2.56244 17.2084 3.11268",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPush);
export default __webpack_public_path__ + "static/media/push.463a8e9e8ab26da56db9c1bb97056397.svg";
export { ForwardRef as ReactComponent };